import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../api/client";

const PrivateRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate replace to="/login" />;
};

export default PrivateRoute;
